import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { ContactModel } from 'src/models';
import { optional } from './common';
// eslint-disable-next-line import/no-cycle
import contactBusinessInfoAdapter from './contactBusinessInfo.adapter';
import contactPersonalInfoAdapter from './contactPersonalInfo.adapter';

const contactAdapter: AdapterFunc<GQL.ContactOutputDto, ContactModel> = (input) => ({
  id: input.id,
  firstName: input.firstName!,
  lastName: input.lastName!,
  title: input.title!,
  notes: input.notes!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
  businessInfo: optional(contactBusinessInfoAdapter, input.businessInfo),
  personalInfo: optional(contactPersonalInfoAdapter, input.personalInfo),
});

export default contactAdapter;
